export const repeatArray = <T>(item: T, times: number) => {
	const a = [];
	for (let i = 0; i < times; i += 1) {
		a.push(item);
	}
	return a;
};

export const sum = (arr: number[]) => arr.reduce((acc, curr) => acc + curr, 0);

export const isSome = (...args: Array<boolean>) => args.some(Boolean);

export const alphabeticalSort = (a: string, b: string) => {
	if (a < b) {
		return -1;
	}
	if (a > b) {
		return 1;
	}
	return 0;
};
